import Vue from 'vue'
import Vuefire from 'vuefire'
import Router from 'vue-router'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'
// import 'vue-material/dist/vue-material.min.css'
import Home from '@/components/Home'
import Set from '@/components/Set'
import Figures from '@/components/Figures'
// import Glossary from '@/components/Glossary'
import Intro from '@/components/Intro'
import About from '@/components/About'
import Visitor from '@/components/Visitor'
import Reference from '@/components/Reference'
import EventOfIreland from '@/components/EventOfIreland'
import SetMap from '@/components/SetMap'
import Waltz from '@/components/Waltz'
import Report from '@/components/Report'
import Event from '@/components/Event'
import AllEvent from '@/components/AllEvent'
import NextEvents from '@/components/NextEvents'
import EditSet from '@/components/EditSet'
import EditEvent from '@/components/EditEvent'
import AddSet from '@/components/AddSet'
import AddEvent from '@/components/AddEvent'
import AddArticle from '@/components/AddArticle'
import AllArticles from '@/components/AllArticles'
import Shinano from '@/components/Shinano'
import SoldiersSong from '@/components/SoldiersSong'
import Hornpipes from '@/components/Hornpipes'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueScrollTo from 'vue-scrollto'
import VueAnalytics from 'vue-analytics'

// import '../theme.scss'

// 踊ったリストの記録、日時、場所、セットリスト
// vue init pwa app_name

Vue.use(Router)
Vue.use(Vuefire)
Vue.use(VueMaterial)
Vue.use(VueYouTubeEmbed)
Vue.use(VueScrollTo, {
  offset: -30
})

// https://github.com/MatteoGabriele/vue-analytics/blob/master/docs/page-tracking.md
// https://github.com/MatteoGabriele/vue-analytics/blob/master/docs/script-loader.md

// セットを更新するときだけコメントアウトする
import db from '../db'
import sets from '../assets/sets.js'
let allSets = db.ref('/sets')
allSets.set(sets)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/set/:setName',
      name: 'Set',
      component: Set
    },
    {
      path: '/set/:setName/figures',
      name: 'Figures',
      component: Figures
    },
    {
      path: '/set/:setName/reports',
      name: 'Report',
      component: Report
    },
    {
      path: '/add/set',
      name: 'AddSet',
      component: AddSet
    },
    {
      path: '/edit/set/:setName',
      name: 'EditSet',
      component: EditSet
    },
    {
      path: '/set/:setName/:figureNumber/:movement/reports',
      name: 'ReportMovement',
      component: Report
    },
    {
      path: '/intro',
      name: 'Intro',
      component: Intro
    },
    {
      path: '/articles/all',
      name: 'AllArticles',
      component: AllArticles
    },
    {
      path: '/article/add',
      name: 'AddArticle',
      component: AddArticle
    },
    {
      path: '/event/add',
      name: 'AddEvent',
      component: AddEvent
    },
    {
      path: '/event/edit/:eventId',
      name: 'EditEvent',
      component: EditEvent
    },
    {
      path: '/event/:eventId',
      name: 'Event',
      component: Event
    },
    {
      path: '/events/nextEvents',
      name: 'NextEvents',
      component: NextEvents
    },
    {
      path: '/events/all',
      name: 'AllEvent',
      component: AllEvent
    },
    {
      path: '/reference',
      name: 'Reference',
      component: Reference
    },
    {
      path: '/eventOfIreland',
      name: 'EventOfIreland',
      component: EventOfIreland
    },
    {
      path: '/setMap',
      name: 'SetMap',
      component: SetMap
    },
    {
      path: '/waltz',
      name: 'Waltz',
      component: Waltz
    },
    {
      path: '/forVisitor',
      name: 'ForVisitor',
      component: Visitor
    },
    {
      path: '/Shinano',
      name: 'Shinano',
      component: Shinano
    },
    {
      path: '/SoldiersSong',
      name: 'SoldiersSong',
      component: SoldiersSong
    },
    {
      path: '/Hornpipes',
      name: 'Hornpipes',
      component: Hornpipes
    },
    {
      path: '/about',
      name: 'About',
      component: About
    }
  ]
})

Vue.use(VueAnalytics, {
  id: 'UA-110199417-1',
  checkDuplicatedScript: true,
  router
})

export default router

Vue.material.registerTheme('default', {
  primary: 'orange',
  accent: 'red',
  warn: 'red'
  // background: 'grey'
})



// WEBPACK FOOTER //
// ./src/router/index.js